module.exports = __webpack_public_path__ + "static/media/articles2.96c8912c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/articles2.png
// module id = 1225
// module chunks = 0